// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboSquareOutlinedSvg from "@fishx/icons-svg/es/asn/WeiboSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareOutlinedSvg
  }));
};

WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
export default React.forwardRef(WeiboSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WeiboSquareOutlined.js
// module id = 4406
// module chunks = 0